import { Chip, TableCell } from '@mui/material';
import { farmStateMapping } from '../../../../Common/Components/StateMappers/farmStateIcons';

interface FarmStateCellProps {
  state: number;
}

export const FarmStateCell: React.FC<FarmStateCellProps> = ({ state }) => {
  const stateInfo = farmStateMapping[state];
  return (
    <TableCell style={{ minWidth: 120 }} align="left">
      <Chip label={stateInfo.label} color={stateInfo.color} />
    </TableCell>
  );
};
